import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { Treeselect } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { useAddIroSectionLinkMutation, useDelIroSectionLinkMutation, useListIroSectionLinksQuery, useListSectionsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'esrs',
  props: {
    iroId: {
      type: String
    }
  },
  emits: ['input'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _normalizer = function normalizer(node) {
      var _node$sections;
      var option = {
        id: node.id,
        label: node.label
      };
      if ((_node$sections = node.sections) !== null && _node$sections !== void 0 && _node$sections.length) {
        // recursive to ensure children are normalized too.
        option.children = node.sections.map(_normalizer);
      }
      return option;
    };
    var _useAddIroSectionLink = useAddIroSectionLinkMutation(),
      addIroSectionLink = _useAddIroSectionLink.mutate;
    var _useDelIroSectionLink = useDelIroSectionLinkMutation(),
      delIroSectionLink = _useDelIroSectionLink.mutate;
    var onSelect = function onSelect(val) {
      if (val.id) {
        addIroSectionLink({
          input: {
            iroId: props.iroId,
            sectionId: val.id
          }
        }).then(function () {
          window.$nuxt.$emit('userMsg');
        });
      } else {
        console.error('val invalid', val);
      }
    };
    var onDeSelect = function onDeSelect(val) {
      if (val.id) {
        delIroSectionLink({
          iroId: props.iroId,
          sectionId: val.id
        }).then(function () {
          refetchLinks();
          window.$nuxt.$emit('userMsg');
        });
      } else {
        console.error('val invalid', val);
      }
    };
    var _useListSectionsQuery = useListSectionsQuery({
        filters: {
          parentIds: [1500]
        }
      }),
      result = _useListSectionsQuery.result;
    var _useListIroSectionLin = useListIroSectionLinksQuery(computed(function () {
        return {
          iroId: props.iroId,
          limit: 200
        };
      }),
      // TODO: max support 200
      computed(function () {
        return {
          enabled: !!props.iroId
        };
      })),
      links = _useListIroSectionLin.result,
      refetchLinks = _useListIroSectionLin.refetch;
    var selected = computed(function () {
      var _links$value, _links$value$listIroS;
      return ((_links$value = links.value) === null || _links$value === void 0 ? void 0 : (_links$value$listIroS = _links$value.listIroSectionLinks) === null || _links$value$listIroS === void 0 ? void 0 : _links$value$listIroS.map(function (link) {
        return link.sectionId;
      })) || [];
    });
    var items = computed(function () {
      var _result$value, _result$value$listSec;
      return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : (_result$value$listSec = _result$value.listSections) === null || _result$value$listSec === void 0 ? void 0 : _result$value$listSec.map(function (node) {
        return _objectSpread(_objectSpread({}, node), {}, {
          isDisabled: true
        });
      })) || [];
    });
    return {
      __sfc: true,
      normalizer: _normalizer,
      emit: emit,
      props: props,
      addIroSectionLink: addIroSectionLink,
      delIroSectionLink: delIroSectionLink,
      onSelect: onSelect,
      onDeSelect: onDeSelect,
      result: result,
      links: links,
      refetchLinks: refetchLinks,
      selected: selected,
      items: items,
      Treeselect: Treeselect
    };
  }
});